export default "__VITE_ASSET__D7y5jN_0__"